// Convention <COLOUR_NAME>_<TINT_PERCENTAGE>
export const ENA_BLUE_1OO = "#00598e"
export const ENA_BLUE_20 = "#ccdde8"

export const ENA_ORANGE_100 = "#ff7232"
export const ENA_ORANGE_20 = "#ffe2d6"

export const ENA_CYAN_100 = "#009fe3"
export const ENA_CYAN_20 = "#cff1ff"

export const WHITE = "#FFFFFF"

export const DARK_THEME_BG_GREY_ONE = "#181c23"
export const DARK_THEME_BG_GREY_TWO = "#242b36"

export const SUCCESS_LIGHT = "#dce7cd"
export const SUCCESS_MAIN = "#2e7d32"
export const SUCCESS_DARK = "#155724"

export const ERROR_LIGHT = "#f9e1e1"
export const ERROR_MAIN = "#d32f2f"
export const ERROR_DARK = "#962020"

export const WARNING_LIGHT = "#fed6b5"
export const WARNING_MAIN = "#ed6c02"
export const WARNING_DARK = "#A04902"
